export const ModalStyles = {
    content: {
        top: 'auto',
        left: '50%',
        right: 'auto',
        bottom: '37px',
        marginRight: '-50%',
        transform: 'translate(-50%)',
        maxWidth: '328px',
        width: '100%',
        padding: '0',
        borderRadius: '20px',
        boxShadow: '0 8px 16px 0 rgba(79, 115, 151, 0.17)',
        border: 'solid 1px #e1e8ee'
    }
}
